import { useAuthenticationStore } from '~/auth/useAuthenticationStore';

import { useAllPermissionsQuery } from './useAllPermissionsQuery';

/**
 * Starts the app's single permission request as early in the session as
 * possible — above the splash gate, before the router mounts — and holds the
 * subscription for as long as the app is running.
 *
 * Correctness does not depend on this winning any race: a feature that reads a
 * permission before the request lands subscribes to the same entry and waits on
 * the same promise. What this buys is timing (the request is already in flight
 * when the first screen mounts) and lifetime (a subscription that outlives every
 * individual consumer, so the entry is never garbage-collected mid-session).
 *
 * Also skips once `requiresReauth` is true, not just when `isLoggedIn` is
 * false. `isLoggedIn` is a cached cookie check and can read true on a
 * session that's already dead server-side. Firing this request then would
 * 401, which forces another logout for a prefetch nobody's waiting on.
 */
export function useInitializeUserPermissions() {
  const { isLoggedIn, requiresReauth } = useAuthenticationStore();

  useAllPermissionsQuery({ skip: !isLoggedIn || requiresReauth });
}
